// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Graph$BlossomPlayground = require("./Graph.bs.js");

var a = Graph$BlossomPlayground.fromList(Belt_List.keepMap({
          hd: [
            "Mary",
            "Joseph",
            40
          ],
          tl: {
            hd: [
              "Mary",
              "Michael",
              40
            ],
            tl: {
              hd: [
                "Joseph",
                "Michael",
                60
              ],
              tl: {
                hd: [
                  "Joseph",
                  "Gabriel",
                  55
                ],
                tl: {
                  hd: [
                    "Michael",
                    "Raphael",
                    55
                  ],
                  tl: {
                    hd: [
                      "Gabriel",
                      "Raphael",
                      50
                    ],
                    tl: {
                      hd: [
                        "Mary",
                        "Paul",
                        15
                      ],
                      tl: {
                        hd: [
                          "Raphael",
                          "Peter",
                          30
                        ],
                        tl: {
                          hd: [
                            "Peter",
                            "John",
                            10
                          ],
                          tl: {
                            hd: [
                              "Paul",
                              "James",
                              10
                            ],
                            tl: {
                              hd: [
                                "Gabriel",
                                "Andrew",
                                30
                              ],
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }, (function (param) {
            var match = Graph$BlossomPlayground.Vertex.make(param[0]);
            var match$1 = Graph$BlossomPlayground.Vertex.make(param[1]);
            if (match !== undefined && match$1 !== undefined) {
              return [
                      Caml_option.valFromOption(match),
                      Caml_option.valFromOption(match$1),
                      param[2]
                    ];
            }
            
          })));

exports.a = a;
/* a Not a pure module */
